export const COMPANY = {
  name: "ANDR BNDT88 TRANS LLC",
  tagline: "Automotive Transport & Vehicle Trading",
  address_line1: "1721 SE 17th Street, Apt 426",
  address_line2: "Fort Lauderdale, FL 33316",
  country: "United States",
  email: "support@andrbndt88.com",
  phone: "+1 276 263 5060",
  phoneHref: "+12762635060",
  established: "2023",
  hours: "Monday – Saturday, 8:00 AM – 6:00 PM ET",
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Vehicle Catalog", path: "/catalog" },
  { label: "Transportation Services", path: "/services" },
  { label: "About Us", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export const INQUIRY_TYPES = [
  "Vehicle Purchase Inquiry",
  "Transportation Quote",
  "General Inquiry",
];

export const SERVICES = [
  {
    key: "vehicle-transportation",
    title: "Vehicle Transportation",
    desc: "Reliable vehicle transportation for individual and commercial customers.",
  },
  {
    key: "interstate",
    title: "Interstate Auto Transport",
    desc: "Long-distance transportation of vehicles between U.S. states.",
  },
  {
    key: "dealer",
    title: "Dealer Transportation",
    desc: "Vehicle movement and logistics support for dealerships and automotive businesses.",
  },
  {
    key: "logistics",
    title: "Automotive Logistics",
    desc: "Coordination of vehicle pickup, transportation, and delivery.",
  },
  {
    key: "export",
    title: "Vehicle Export Support",
    desc: "Transportation and logistics coordination for vehicles intended for export.",
  },
];

export const IMAGES = {
  heroTransport:
    "https://images.unsplash.com/photo-1761917904658-2a9ecb84a169?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxjYXIlMjB0cmFuc3BvcnQlMjB0cmFpbGVyJTIwdHJ1Y2slMjBlbmNsb3NlZCUyMGNhciUyMGhhdWwlMjBhdXRvJTIwdHJhbnNwb3J0JTIwZGVsaXZlcnl8ZW58MHx8fHwxNzkxMzE4Nzk3fDA&ixlib=rb-4.1.0&q=85",
  towFlatbed:
    "https://images.unsplash.com/photo-1719295260617-310c1b182295?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxjYXIlMjB0cmFuc3BvcnQlMjB0cmFpbGVyJTIwdHJ1Y2slMjBlbmNsb3NlZCUyMGNhciUyMGhhdWwlMjBhdXRvJTIwdHJhbnNwb3J0JTIwZGVsaXZlcnl8ZW58MHx8fHwxNzkxMzE4Nzk3fDA&ixlib=rb-4.1.0&q=85",
  enclosedHauler:
    "https://images.unsplash.com/photo-1767554557087-c51166d54023?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxjYXIlMjB0cmFuc3BvcnQlMjB0cmFpbGVyJTIwdHJ1Y2slMjBlbmNsb3NlZCUyMGNhciUyMGhhdWwlMjBhdXRvJTIwdHJhbnNwb3J0JTIwZGVsaXZlcnl8ZW58MHx8fHwxNzkxMzE4Nzk3fDA&ixlib=rb-4.1.0&q=85",
  dealershipLot:
    "https://images.unsplash.com/photo-1574023240744-64c47c8c0676?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHxfHx1c2VkJTIwc2VkYW4lMjBTVVYlMjB0cnVjayUyMGNhciUyMGRlYWxlcnNoaXAlMjBpbnZlbnRvcnklMjB2ZWhpY2xlJTIwdHJhZGluZ3xlbnwwfHx8fDE3OTEzMTg3OTd8MA&ixlib=rb-4.1.0&q=85",
};

export const formatMiles = (m) => `${m.toLocaleString("en-US")} mi`;
export const formatPrice = (p) => `$${p.toLocaleString("en-US")}`;
